const GetDataFromLocalStorage = (key) => {
  return JSON.parse(localStorage.getItem(key)) || []
}
export default GetDataFromLocalStorage
